import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFolderSchema } from 'validation/form/file';
import { useSelector } from 'react-redux';
import { useFile } from 'hooks/useFile';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';

export const NewFolder = (props) => {
  const { close } = props;

  const fileFormLoading = useSelector((state) => state.files.fileForm.loading);
  const currentPropertyId = useSelector((state) => state.properties.currentProperty?.id);

  const { fileId, id: propertyId } = useParams();
  const { handleCreateFolder } = useFile();

  const methods = useForm({ resolver: yupResolver(createFolderSchema) });

  const parentId = useMemo(() => {
    if (fileId) {
      return fileId;
    }
    if (propertyId && currentPropertyId) {
      return currentPropertyId;
    }
    return null;
  }, [fileId, propertyId, currentPropertyId]);

  const handleSave = methods.handleSubmit((data) => {
    handleCreateFolder(data, parentId, close);
  });

  return (
    <DrawerContent>
      <DrawerContent.Header title="New Folder" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormTextField
              name="name"
              label="Folder Name"
              control={methods.control}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Create"
          submitButtonLoading={fileFormLoading}
          submit={handleSave}
          close={close}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
